import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { adminFetch, ADMIN_ENDPOINTS } from '../config';
import './Admin.css';

export default function AdminDashboard() {
  const [counts, setCounts] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    adminFetch(ADMIN_ENDPOINTS.dashboardCounts)
      .then((res) => res.json())
      .then((data) => {
        if (!cancelled && data.error) setError(data.error);
        else if (!cancelled) setCounts(data);
      })
      .catch(() => !cancelled && setError('Failed to load'));
    return () => { cancelled = true; };
  }, []);

  if (error) return <div className="admin-content"><p style={{ color: 'var(--admin-danger)' }}>{error}</p></div>;
  if (!counts) return <div className="admin-content"><p>Loading…</p></div>;

  const cards = [
    { label: 'About', count: counts.about, link: '/admin/about' },
    { label: 'Services', count: counts.services, link: '/admin/services' },
    { label: 'Projects', count: counts.projects, link: '/admin/projects' },
    { label: 'Education', count: counts.education, link: '/admin/education' },
    { label: 'Contact Messages', count: `${counts.messages} total (${counts.unreadMessages} unread)`, link: '/admin/messages' },
    { label: 'Skills', count: 'Categories & items', link: '/admin/skills' },
  ];

  return (
    <>
      <h1>Dashboard</h1>
      <p className="page-subtitle">Welcome to your portfolio admin. Manage your site content below.</p>
      <div className="grid-2">
        {cards.map(({ label, count, link }) => (
          <div key={link} className="card">
            <h2>{label}</h2>
            <p>{count}</p>
            <Link to={link} className="btn btn-sm">Manage</Link>
          </div>
        ))}
      </div>
    </>
  );
}
